export const FigureModalSource = {
    FILE_TREE: "file_tree",
    FROM_URL: "from_url",
    FILE_UPLOAD: "upload",
    EDIT_FIGURE: "edit",
};

export function createDefaultFigureDraft(overrides = {}) {
    return {
        path: "",
        width: "0.5",
        includeCaption: true,
        includeLabel: false,
        captionText: "",
        labelText: "",
        ...overrides,
    };
}

export function inferFigureTextFromPath(path, draft = {}) {
    const trimmedPath = String(path || "").trim();
    const inferredName = trimmedPath.split("/").pop() || "";
    const inferredStem = inferredName.replace(/\.[^.]+$/, "") || "image";

    return {
        captionText:
            !draft?.captionText || draft.captionText === "" || draft.captionText === "Enter Caption"
                ? inferredName
                : draft.captionText,
        labelText:
            draft?.includeLabel && (!draft?.labelText || draft.labelText === "fig:placeholder")
                ? `fig:${inferredStem}`
                : draft?.labelText || "",
    };
}
